import { Dialog, Portal, Textarea } from '@chakra-ui/react'
import type { FC } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { Field } from '@app/components/ui/field'
import { useStore } from '@app/store'
import type { DomainBusinessContext } from '@app/types'
import { BusinessContextGenerate } from '@graphql/documents/business_context.graphql'

interface Props {
  businessContext?: DomainBusinessContext
  open: boolean
  onOpenChange: (e: { open: boolean }) => void
  loading?: boolean
}

const GenerateContextDialog: FC<Props> = ({ businessContext, open, onOpenChange, loading: parentLoading = false }) => {
  const [loading, setLoading] = useState(false)
  const [initialContext, setInitialContext] = useState('')
  const actionMutation = useStore.use.actionMutation()

  const handleGenerate = async () => {
    setLoading(true)

    await actionMutation(BusinessContextGenerate, {
      businessContextId: businessContext?.id,
      initialContext
    }).finally(() => {
      onOpenChange({ open: false })
      setInitialContext('')
      setLoading(false)
    })
  }

  return (
    <Dialog.Root placement="center" lazyMount onOpenChange={onOpenChange} open={open}>
      <Dialog.Trigger asChild>
        <Button colorPalette="purple" variant="surface" loading={parentLoading}>
          Generate AI Context
        </Button>
      </Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Generate AI Context</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Field label="Initial context">
                <Textarea
                  name="initialContext"
                  placeholder="This will take a minute or two. You can provide some initial context to help the AI generate a more relevent business context."
                  autoComplete="off"
                  rows={3}
                  value={initialContext}
                  onChange={(e) => setInitialContext(e.target.value)}
                />
              </Field>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="outline" onClick={() => onOpenChange({ open: false })}>
                Cancel
              </Button>
              <Button colorPalette="purple" variant="surface" loading={loading} onClick={handleGenerate}>
                Generate
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}

export default GenerateContextDialog
